// extracted by mini-css-extract-plugin
module.exports = {"internalError":"InternalError_internalError__1lE3h","card":"InternalError_card__3HQ3Q","icon":"InternalError_icon__2j_fd","buttonLink":"InternalError_buttonLink__zFzyN"};